import "@fontsource/lexend";
import "@fontsource/lexend/600.css";
import "@fontsource/lexend/700.css";
import { RouteObject, useRoutes } from "react-router-dom";
import "./App.less";
import AuthProvider from "./context/AuthContext";
import "./fonts/digital_number_font.css";
import LoginPage from "./pages/LoginPage";
import LoginForm from "./pages/LoginPage/LoginForm";
import DashboardPage from "./pages/DashboardPage";
import { LOGIN_PHONE_TITLE, LOGIN_PHONE_SUBTITLE, ePageLink } from "./common/constants";

export default function App() {
  let routes: RouteObject[] = [
    {
      children: [
        {
          path: ePageLink.LOGIN,
          index: true,
          element: <LoginPage Element={LoginForm} title={LOGIN_PHONE_TITLE} subtitle={LOGIN_PHONE_SUBTITLE} />,
        },
      ],
    },
    {
      path: "/*",
      element: (
        <DashboardPage />
      ),
    },
  ];
  let element = useRoutes(routes);
  return <>
    <AuthProvider>
      {element}
    </AuthProvider>
  </>;
}
